module.exports = __webpack_public_path__ + "img/incomeLossFromHousingProperty.11fdf8e8.svg";